class PreserveScrollProducts extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.productGridUl = this.querySelector('#product-grid');
        this.productGridPagination = document.querySelector('#product-grid-pagination');
        const productGridObserver = new MutationObserver(() => {
            this.saveOnLoad();
        });

        productGridObserver.observe(this.productGridUl, { childList: true, subtree: true });


        // this.searchloadMoreBtn = document.querySelector('#product-grid-pagination .pagination__load-button.search-load-more');
        // if(this.searchloadMoreBtn){
        //     this.searchloadMoreBtn.addEventListener('click', this.saveOnLoad.bind(this));
        // }

        this.preserveScroll();
    }

    saveOnLoad() {
        // setTimeout(() => {
            const productGridHtml = this.productGridUl.innerHTML;
            sessionStorage.setItem('productGridHtml', productGridHtml);
            sessionStorage.setItem('productGridPagination', this.productGridPagination.innerHTML);

            // const tagalysPaginationLinks = document.querySelector(".pagination-wrapper.tagalys-pagination-links");
            // const paginationStatusCaption =  document.querySelector(".pagination__status.caption");
            
            // if(tagalysPaginationLinks && paginationStatusCaption)
            // {
            //     sessionStorage.setItem("tagalysPaginationLinks", tagalysPaginationLinks.innerHTML);
            //     sessionStorage.setItem("paginationStatusCaption", paginationStatusCaption.innerHTML);
            // }
            
            
        // }, 2000);
    }
    

    preserveScroll() {
        //check if the secondlast visted pade is a product page
        const secondLastVisitedPage = sessionStorage.getItem('secondLastVisitedPage');
        const thirdLastVisitedPage = sessionStorage.getItem('thirdLastVisitedPage');

        if (secondLastVisitedPage && secondLastVisitedPage.includes('/products/') && thirdLastVisitedPage && thirdLastVisitedPage.split("&")[0] == window.location.href.split("&")[0]) {
            
            const storedProductGridHtml = sessionStorage.getItem('productGridHtml');
            if(storedProductGridHtml)
            {
                this.productGridUl.innerHTML = storedProductGridHtml;
            }

            if(window.location.href.includes("/search")) {
                // const tagalysPaginationLinks = document.querySelector(".pagination-wrapper.tagalys-pagination-links");
                // const paginationStatusCaption =  document.querySelector(".pagination__status.caption");
                
                
                // const storedTagalysPaginationLinks = sessionStorage.getItem("tagalysPaginationLinks");
                // const storedPaginationStatusCaption = sessionStorage.getItem("paginationStatusCaption");

                // tagalysPaginationLinks.innerHTML = storedTagalysPaginationLinks;
                // paginationStatusCaption.innerHTML = storedPaginationStatusCaption;
                
            } 
            else {
                const storedProductGridPagination = sessionStorage.getItem('productGridPagination');
                if (this.productGridPagination && storedProductGridPagination) {
                    this.productGridPagination.innerHTML = storedProductGridPagination;
                }
            }


            //extract product handle and  scroll into view
            let productHandle = secondLastVisitedPage.split('/products/')[1];
            productHandle = productHandle.split('/')[0];
            productHandle = productHandle.split('?')[0];

            const prodLiId = "prod_li_" + productHandle;
            const prodLi = document.querySelector('#' + prodLiId);
            if (prodLi) {
                prodLi.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else {
                console.warn('Product LI not found:', prodLiId);
            }

        }
        else {
            this.saveOnLoad();
        }
    }

} 

customElements.define('preserved-scroll-products', PreserveScrollProducts);